export default __webpack_public_path__ + "BiodieselDefaultPin.png";